import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { formatDate } from "../../../common/Validations";
import { SearchField } from "../../../Components/formElements/SearchField";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
// import CommonItemLevelDatatableModal from "../../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import ItemService from "../../../services/inventory_appCommonService";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import toast from "react-hot-toast";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import CancelModal from "../../../Components/CancleModal/CancelModal";
import { getModuleStats } from "../../../redux/feature/warehouse_app/warehouseSlice";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import WarehouseConstants from "../../../common/WarehouseConstants";
import { addAttendance, getAtdList } from "../../../redux/feature/hr_app/hrSlice";
import HRConstants from "../../../common/HRConstants";

const AttendanceList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Warehouse");
  localStorage.setItem("submenu", "Warehouse");

  let atdData = useSelector((state) => state?.hr?.atd); // User Details from Store
  let atdDatatable = useSelector(
    (state) => state?.hr?.atd?.pagination,
  ); // User Details from Store

  const moduleStats = useSelector((state) => state.warehouse.moduleStats.data);
  const statsPayload = {
    dashboard: "hr_module",
    chartFilterType: "Yearly",
    chartInput2: new Date().getFullYear(),
  };

  const refreshWarehousePage = () => {
    dispatch(getAtdList(DEFAULT_LIST_PARAMS));
    dispatch(getModuleStats(statsPayload));
  };

  useEffect(() => {
    refreshWarehousePage();
    // eslint-disable-next-line
  }, [dispatch]);

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [actionType, setActionType] = useState("Cancel");
  const [getSelectedRows, setSelectedRows] = useState([]);
  const [singleCancelRow, setSingleCancelRow] = useState(null);
  const cancelModalShow = (row = null, type = "Cancel") => {
    setActionType(type);
    if (row) {
      setSingleCancelRow(row);
    } else {
      setSingleCancelRow(null);
    }
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
    setSingleCancelRow(null);
    setActionType("Cancel");
  };
  const cancelRows = singleCancelRow ? [singleCancelRow] : getSelectedRows;
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) =>
        item?.headerStatus !== "Cancelled" && item?.headerStatus !== "Deleted",
    );
    setSelectedRows(validRows);
    setSelectedRowIds(validRows.map((item) => String(item.attendanceNr)));
  };

  useEffect(() => {
    if (!showStats) {
      setFilteredData(atdData.data);
    }
  }, [showStats, atdData]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  /* Modal Function */
  const attendanceCal = () => {
    navigate(WarehouseConstants.WH_WAREHOUSE_CREATION);
  };
  const detailedPage = (attendanceNr) => {
    dispatch(addAttendance(attendanceNr));
    navigate(HRConstants.HR_ATD_DETAILS);
  };
  //on page load
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  const DEFAULT_LIST_PARAMS = {
    queryName: "Get_HRAttendance_List",
    module: "",
    page: 1,
    per_page: 10,
  };
  const handleCancelAPI = async (modalPayload = {}) => {
    try {
      const rows = singleCancelRow ? [singleCancelRow] : getSelectedRows;

      const payload = {
        documentNumber: rows.map((item) => item.attendanceNr),
        actionType,
        cancellationRemark: modalPayload?.cancellationRemark || "",
      };

      const res = await ItemService.cancelWH(payload);

      if (res?.status === 200) {
        toast.success(res?.message || `${actionType} successful`, {
          duration: 3000,
          position: "top-right",
        });

        refreshWarehousePage();
        return res;
      } else {
        toast.error(res?.message || `${actionType} failed. Please try again!`, {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error(`${actionType} API Error:`, err);
      toast.error(err?.response?.data?.message || "Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
      return null;
    }
  };
  const columns = [
    {
      name: "Attendance Nr",
      id: "attendanceNr",
      cell: (row) => {
        const docNo = row.attendanceNr || row.draftNr;

        return (
          <button className="btnInfo" onClick={() => detailedPage(docNo, row)}>
            {docNo}
          </button>
        );
      },
      width: "150px",
    },
    {
      name: "Employee Name",
      id: "employeeName",
      dropDown: "true",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.employeeName} </p>
          <p className="m-0 p-0 fw-bold">{row.employeeCode} </p>
        </div>
      ),
      selector: (row) => row.employeeName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      selector: (row) => row.status || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Attendance Date",
      selector: (row) => formatDate(row.attendanceDate),
      sortable: true,
      width: "160px",
    },
    {
      name: "Start Time",
      selector: (row) => row.startTime || "--",
      id: "city",
      dropDown: "true",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.startTime} </p>
          {/* <p className="m-0 p-0 fw-bold">{row.address2} </p> */}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "End Time",
      selector: (row) => row.endTime || "--",
      id: "endTime",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.endTime} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      cell: (row) => {
        const status = row?.headerStatus;
        const isCancelled = status === "Cancelled";
        const isDeleted = status === "Deleted";
        const docNo = row.attendanceNr || row.draftNr;
        return (
          <TableActions
            selectedRow={selectedRowIds.includes(String(docNo))}
            actions={[
              {
                key: "details",
                label: "Details",
                icon: "bi bi-info-circle",
              },
              {
                key: "edit",
                label: "Edit",
                icon: "bi bi-pencil-square",
                onClick: () => detailedPage(docNo, row),
                disabled: isDeleted,
              },
              {
                key: "cancel",
                label: "Cancel",
                icon: "bi bi-x-circle",
                onClick: () => cancelModalShow(row, "docNo"),
                selectRow: true,
                disabled: isCancelled || isDeleted,
              },
              {
                key: "delete",
                label: "Delete",
                icon: "bi bi-trash",
                onClick: () => cancelModalShow(row, "Delete"),
                selectRow: true,
                disabled: isDeleted,
              },
              {
                key: "more",
                label: "More",
                icon: "bi bi-three-dots",
                onClick: () => console.log("More", row),
              },
            ]}
          />
        );
      },
      width: "180px",
    },
  ];
  const loadInitialPoData = async () => {
    setData(atdData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_HRAttendance_List",
      module: "WAREHOUSE",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getAtdList(obj));
    setData(atdData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_HRAttendance_List",
      module: "WAREHOUSE",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getAtdList(obj));
    setData(atdData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_HRAttendance_List",
      module: "WAREHOUSE",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getAtdList(obj));
  };

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_HRAttendance_List",
      module: "WAREHOUSE",
      page: 1,
      per_page: 10,
    };
    dispatch(getAtdList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialPoData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atdData]);

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_HRAttendance_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getAtdList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Attendance</h2>
                <p className="subText">Lists of Attendance and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                fetchFunction={ItemService.getAtdList} // Replace with your actual fetch function
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>
                <StatisticsContainer
                  statsMode="redux"
                  reduxStats={moduleStats}
                  reduxKey="attendance"
                  keyName="status"
                  paginatedList={atdData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Attendance List</span>
                      <span className="subHeaderTitle">View of Attendance </span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => attendanceCal()}
                        >
                          <i className="bi bi-clipboard-check"></i> Attendance Cal
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={atdData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={atdDatatable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title={
          actionType === "Delete"
            ? "Delete the Warehouse"
            : "Cancel the Warehouse"
        }
        type="WH"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={cancelRows}
        onConfirm={handleCancelAPI}
        docKey="attendanceNr"
        onSuccess={() => {
          setSelectedRows([]);
          setSelectedRowIds([]);
          setSingleCancelRow(null);
          setActionType("Cancel");
          refreshWarehousePage();
        }}
      />
    </main>
  );
};

export default AttendanceList;
